import React from 'react';
import { Link } from 'react-router-dom';
import { AlertTriangle, Mail } from 'lucide-react';

export function NoFileResult() {
  return (
    <div className="grid lg:grid-cols-2 gap-4" data-testid="demo-seller-result">
      <ul className="space-y-2">
        <li className="flex gap-3 text-sm text-gray-300" data-testid="demo-seller-nofile-fetch"><AlertTriangle className="w-4 h-4 mt-0.5 shrink-0 text-amber-400" />shop.example/.well-known/claim-records.json returned HTTP 404</li>
        <li className="flex gap-3 text-sm text-gray-300" data-testid="demo-seller-nofile-key"><AlertTriangle className="w-4 h-4 mt-0.5 shrink-0 text-amber-400" />No store signing key, so no signed receipt is possible</li>
      </ul>
      <div className="rounded-xl border border-amber-500/50 p-4 text-sm text-amber-100/90 space-y-2" data-testid="demo-seller-verdict">
        <p><span className="font-semibold">Not confirmed.</span> shop.example has no claims file. The seller agent is not blocked and not trusted.</p>
        <p className="flex gap-2"><Mail className="w-4 h-4 mt-0.5 shrink-0" />Send the claim through the store's normal order channel, for example the contact address in the order confirmation.</p>
        <p className="text-xs text-gray-400">The agent keeps its own record: claim ID, spoken code, and time sent. That shows when it sent the claim, not when the store got it.</p>
        <Link to="/specs/claim-records/comments" className="inline-block text-xs text-violet-300 hover:text-violet-200" data-testid="demo-seller-nofile-q3-link">How long should a claims file count as current? Open question Q-3</Link>
      </div>
    </div>
  );
}
